import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { SelectingType } from "./zonesSlice";

export type FleetModeType = "cars" | "drivers" | null;

interface IState {
  mode: FleetModeType;
  driverName: string;
  plaque: any;
  visible: boolean;
  pointwiseShow: boolean;
  trafficFleetShowType: number;
}

const initialState: IState = {
  mode: null,
  driverName: " ",
  plaque: { plaquePart1: "", plaquePart2: "", plaquePart3: "", plaquePart4: "" },
  visible: false,
  pointwiseShow: false,
  trafficFleetShowType: 0,
};

export const trafficFleetSlice = createSlice({
  name: "trafficFleet",
  initialState,
  reducers: {
    changeMode: (state, action: PayloadAction<FleetModeType>) => {
      return { ...state, mode: action.payload };
    },
    changeDriverName: (state, action: PayloadAction<string>) => {
      return { ...state, driverName: action.payload };
    },
    changePlaque: (state, action: PayloadAction<any>) => {
      return { ...state, plaque: action.payload };
    },
    toggleVisibility: (state) => {
      return { ...state, visible: !state.visible };
    },
    togglePointwiseShow: (state) => {
      return { ...state, pointwiseShow: !state.pointwiseShow };
    },
    changeTrafficFleetShowType: (state, action: PayloadAction<number>) => {
      return { ...state, trafficFleetShowType: action.payload };
    },
  },
});

export const { changeMode, changeDriverName, changePlaque, toggleVisibility, togglePointwiseShow, changeTrafficFleetShowType } =
  trafficFleetSlice.actions;

export default trafficFleetSlice.reducer;
